import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import MentorHubTabs from '../../components/MentorHub/MentorHubTabs';
import MenteeGoals from '../Goals/MenteeGoals';
import MentorGoals from '../Goals/MentorGoals';
import MenteeMatching from '../Matching/MenteeMatching';
import MentorMatching from '../Matching/MentorMatching';
import MessagingHub from '../Messaging/MessagingHub';
interface MentorHubProps {
  userType: 'mentor' | 'mentee' | null;
}
const MentorHub: React.FC<MentorHubProps> = ({
  userType
}) => {
  const {
    tab = 'goals'
  } = useParams<{
    tab?: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'goals' | 'matching' | 'messages'>(tab as 'goals' | 'matching' | 'messages');
  // Update active tab when URL changes
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const currentTab = pathParts[pathParts.length - 1];
    if (['goals', 'matching', 'messages'].includes(currentTab)) {
      setActiveTab(currentTab as 'goals' | 'matching' | 'messages');
    } else {
      // Default to goals if invalid tab
      navigate('/mentor-hub/goals', {
        replace: true
      });
    }
  }, [location.pathname, navigate]);
  const handleTabChange = (newTab: 'goals' | 'matching' | 'messages') => {
    setActiveTab(newTab);
  };
  const renderContent = () => {
    switch (activeTab) {
      case 'goals':
        return userType === 'mentor' ? <MentorGoals data-id="element-1772" /> : <MenteeGoals data-id="element-1773" />;
      case 'matching':
        return userType === 'mentor' ? <MentorMatching userType={userType} data-id="element-1774" /> : <MenteeMatching userType={userType} data-id="element-1775" />;
      case 'messages':
        return <MessagingHub data-id="element-1776" />;
      default:
        return userType === 'mentor' ? <MentorGoals data-id="element-1777" /> : <MenteeGoals data-id="element-1778" />;
    }
  };
  return <div className="pb-4 animate-fade-in" data-id="element-1779">
      <div className="mb-2" data-id="element-1780">
        <h1 className="text-2xl font-bold text-purple-900" data-id="element-1781">Mentor Hub</h1>
        <p className="text-purple-500 text-sm" data-id="element-1782">
          Manage your mentorship journey in one place
        </p>
      </div>
      <MentorHubTabs userType={userType} activeTab={activeTab} onTabChange={handleTabChange} data-id="element-1783" />
      <div className="mentor-hub-content animate-slide-up" data-id="element-1784">
        {renderContent()}
      </div>
    </div>;
};
export default MentorHub;